module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/feature-4.png?fa0621ba";